module.exports = __webpack_public_path__ + "img/cliff-outer-shadow.efa12d16.png";